import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { HeaderMainViewComponent } from './header-main-view/header-main-view.component';
import { HeaderDeliveryViewComponent } from './header-delivery-view/header-delivery-view.component';
import { HeaderAnonymousComponent } from './header-anonymous/header-anonymous.component';
import { FavoriteBtnModule } from '../delivery-list/shared/favorite-btn/favorite-btn.module';
import { DownloadBtnModule } from '../delivery-list/shared/download-btn/download-btn.module';
import { HeaderMainService } from './header-main-view.service';
import { mainHeaderKey, headerReducer } from './header-main-view/store/header.reducer';
import { MainHeaderEffects } from './header-main-view/store/header.effects';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FavoriteBtnModule,
    DownloadBtnModule,
    StoreModule.forFeature(mainHeaderKey, headerReducer),
    EffectsModule.forFeature([MainHeaderEffects]),
  ],
  exports: [HeaderMainViewComponent, HeaderDeliveryViewComponent, HeaderAnonymousComponent],
  declarations: [HeaderMainViewComponent, HeaderDeliveryViewComponent, HeaderAnonymousComponent],
  providers: [HeaderMainService],
})
export class HeaderModule {}
